import {event} from "d3-selection";

export function nopropagation() {
  event.stopImmediatePropagation();
}

export default function() {
  event.preventDefault();
  event.stopImmediatePropagation();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-zoom/src/noevent.js
// module id = 899
// module chunks = 0